const registry = new Map();
const pending = new WeakSet();
const generations = new WeakMap();

async function activate(section) {
  if (!(section instanceof HTMLElement) || section.dataset.p2Loaded === 'true' || pending.has(section)) return;
  const generation = generations.get(section) || 0;
  generations.set(section, generation);
  pending.add(section);
  try {
    const module = await import(section.dataset.p2ModuleUrl);
    if (!section.isConnected || generations.get(section) !== generation) return;
    const cleanup = await module.mount?.(section);
    if (!section.isConnected || generations.get(section) !== generation) {
      cleanup?.();
      return;
    }
    section.dataset.p2Loaded = 'true';
    if (typeof cleanup === 'function') registry.set(section, cleanup);
  } catch (error) {
    if (section.isConnected) section.dataset.p2Loaded = 'error';
    console.warn('[SkyTrove] Section enhancement unavailable', error);
  } finally {
    pending.delete(section);
  }
}

const observer = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;
    observer.unobserve(entry.target);
    entry.target.removeAttribute('data-p2-observed');
    activate(entry.target);
  }
}, { rootMargin: '300px 0px' });

function observe(root = document) {
  const sections = [
    ...(root.matches?.('[data-p2-module-url]:not([data-p2-loaded]):not([data-p2-observed])') ? [root] : []),
    ...(root.querySelectorAll?.('[data-p2-module-url]:not([data-p2-loaded]):not([data-p2-observed])') ?? []),
  ];
  for (const section of sections) {
    section.dataset.p2Observed = 'true';
    observer.observe(section);
  }
}

observe();

document.addEventListener('shopify:section:load', (event) => observe(event.target));

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target?.matches?.('[data-p2-module-url]') ? event.target : event.target?.querySelector?.('[data-p2-module-url]');
  if (!section) return;
  generations.set(section, (generations.get(section) || 0) + 1);
  pending.delete(section);
  observer.unobserve(section);
  section.removeAttribute('data-p2-observed');
  section.removeAttribute('data-p2-loaded');
  registry.get(section)?.();
  registry.delete(section);
});
